import {FormioBase} from "./formiobase";

export class Table extends FormioBase {
  public inputType = "table";
  public title = "Table";
  public icon = "fa fa-table";
  public shouldBeRenderedByFormio = false;
  public schema: any = {
    title: "Table",
    components: [
      {
        input: false,
        key: "",
        inputType: "table",
        rows: [],
        header: [],
        caption: "",
        striped: false,
        bordered: false,
        hover: false,
        condensed: false,
        multiple: false,
        type: "table",
        tags: [],
        description: "",
        customClass: "ds-table",
      },
    ],
    display: "",
    page: 0,
  };
}
